// EXEC DayTypesAllowTourScheduling 'true',1563,null,25,'true',1

const dayTypes = [
  {
    id: 6,
    name: 'Personal Business',
    abbreviation: 'PP',
    approvalNeeded: 1
  },
  {
    id: 7,
    name: 'Holiday Taken',
    abbreviation: 'HOL',
    approvalNeeded: 1
  },
  {
    id: 8,
    name: 'VX',
    abbreviation: 'VX',
    approvalNeeded: 1
  },
  {
    id: 46,
    name: 'Not Available (DH/FL Only)',
    abbreviation: 'NA',
    approvalNeeded: 0
  },
  {
    id: 31,
    name: 'Vacation',
    abbreviation: 'VAC',
    approvalNeeded: 1
  },
  {
    id: 35,
    name: 'Death In Family',
    abbreviation: 'DIF',
    approvalNeeded: 1
  },
  {
    id: 60,
    name: 'Last Year\'s Vacation Day (s)',
    abbreviation: 'LVD',
    approvalNeeded: 1
  },
  {
    id: 83,
    name: 'Available',
    abbreviation: 'NA',
    approvalNeeded: 0
  },
  {
    id: 10,
    name: 'Off OUT of VAC',
    abbreviation: 'OUT',
    approvalNeeded: 1
  },
  {
    id: 11,
    name: 'Off IN to VAC',
    abbreviation: 'IN',
    approvalNeeded: 1
  },
  {
    id: 4,
    name: 'Payback, Non Mand',
    abbreviation: 'PBN',
    approvalNeeded: 1
  },
  {
    id: 5,
    name: 'Payback, Early',
    abbreviation: 'PBE',
    approvalNeeded: 1
  },
  {
    id: 16,
    name: 'Requested OFF',
    abbreviation: 'RQ',
    approvalNeeded: 1
  },
  {
    id: 26,
    name: 'Payback, Mandatory',
    abbreviation: 'PBM',
    approvalNeeded: 1
  },
  {
    id: 61,
    name: 'Comp Day Used',
    abbreviation: 'CMPU',
    approvalNeeded: 1
  },
  {
    id: 3,
    name: 'Unpaid Leave',
    abbreviation: 'LOA',
    approvalNeeded: 1
  },
  {
    id: 77,
    name: 'Holiday (Management)',
    abbreviation: 'HM',
    approvalNeeded: 1
  },
  {
    id: 9,
    name: 'Jury Duty',
    abbreviation: 'JUR',
    approvalNeeded: 1
  },
  {
    id: 69,
    name: 'Grand Jury',
    abbreviation: 'GJU',
    approvalNeeded: 1
  },
  {
    id: 73,
    name: 'COMP DAY PAID (MGM ONLY)',
    abbreviation: 'PDC',
    approvalNeeded: 1
  },
  {
    id: 55,
    name: '1/2 Payback Day',
    abbreviation: 'PB.5',
    approvalNeeded: 1
  },
  {
    id: 56,
    name: '1/2 Personal Day',
    abbreviation: 'PP.5',
    approvalNeeded: 1
  },
  {
    id: 48,
    name: '1/2 Vacation Day',
    abbreviation: 'V.5',
    approvalNeeded: 1
  },
  {
    id: 185,
    name: '1/2 Last Year\'s Vacation Day',
    abbreviation: 'LVD.5',
    approvalNeeded: 1
  },
  {
    id: 130,
    name: 'Holiday Worked (Mgmt only)',
    abbreviation: 'HW',
    approvalNeeded: 0
  },
  {
    id: 84,
    name: 'Parental Leave (Baby Bonding)',
    abbreviation: 'PL',
    approvalNeeded: 1
  },
  {
    id: 88,
    name: 'Military Leave',
    abbreviation: 'M',
    approvalNeeded: 1
  },
  {
    id: 93,
    name: 'VACATION - KVEA ONLY!',
    abbreviation: 'KVD',
    approvalNeeded: 1
  },
  {
    id: 94,
    name: 'AVAILABLE - TELEMUNDO ONLY',
    abbreviation: 'AVT',
    approvalNeeded: 0
  },
  {
    id: 106,
    name: 'Vacation for Holiday WNJU Only',
    abbreviation: 'VHO',
    approvalNeeded: 0
  },
  {
    id: 107,
    name: 'WNJU COMP DAY',
    abbreviation: 'WCD',
    approvalNeeded: 1
  },
  {
    id: 108,
    name: 'WNJU COMP DAY PLACE HOLDER',
    abbreviation: 'CDP',
    approvalNeeded: 0
  },
  {
    id: 132,
    name: 'FLOATING HOL IUOE WRC',
    abbreviation: 'FLHOL',
    approvalNeeded: 0
  },
  {
    id: 166,
    name: 'WVIT Personal Holiday AFTRA',
    abbreviation: 'FLHOL',
    approvalNeeded: 0
  },
  {
    id: 136,
    name: 'Vacation Page None-Paid',
    abbreviation: 'VNP',
    approvalNeeded: 1
  },
  {
    id: 181,
    name: 'AVAILABLE-ALL HOURS',
    abbreviation: 'AVALL',
    approvalNeeded: 1
  },
  {
    id: 182,
    name: 'AVAILABLE-AM',
    abbreviation: 'AV-AM',
    approvalNeeded: 1
  },
  {
    id: 183,
    name: 'AVAILABLE-PM',
    abbreviation: 'AV-PM',
    approvalNeeded: 1
  },
  {
    id: 184,
    name: 'AVAILABLE-OVERNIGHT',
    abbreviation: 'AV-OV',
    approvalNeeded: 1
  },
];

export default dayTypes;

